import Vue from 'vue'
import Vuex from 'vuex'
import {ajax} from '../assets/js/ajax'

Vue.use(Vuex)
const state = {
    certificationStatus: ''
}
const mutations = {
   CHANGE (state,status) {
    state.certificationStatus = status;
  },
  
}
const actions = {
  async changCertific ({commit}, id) {
    const result = await ajax('/pc/company/getCompanyOne',{id:id},'POST')
    commit('CHANGE',result.data.certificationStatus)
  },
  setCertific({commit},state){
    commit('CHANGE',state)
  }
  
}
const getters = {}
export default new Vuex.Store({
  state, // 状态对象
  mutations, // 包含多个更新state函数的对象
  actions, // 包含多个对应事件的回调函数的对象
  getters// 包含多个getter计算属性函数的对象
})


// WEBPACK FOOTER //
// ./src/store/store.js